<template>
  <div>
    <div class="list-group song-list">
      <div class="list-group-item justify-content-center fs-5">
        {{ artist.name }}
      </div>
      <div class="list-group-item">
        <router-link to="/">← All Artists</router-link>
      </div>
      <sidebar-nav :artist="artist" :urlPrefix="urlPrefix" />
      <sidebar-songs :songs="filteredSongs" :urlPrefix="urlPrefix" />
      <a v-if="userRole === 'guest'" href="/users/sign_up" class="list-group-item upload-button">Sign Up</a>
      <router-link v-else to="/mixes/new" class="list-group-item upload-button">↑ Upload a mix</router-link>
    </div>
    <div class="flex-grow-1 filler"></div>
  </div>
</template>

<script>
import SidebarNav from './sidebar_nav.vue'
import SidebarSongs from './sidebar_songs.vue'

export default {
  components: { SidebarNav, SidebarSongs },
  props: {
    artist: { type: Object, required: true },
    songs: { type: Array, default: () => [] },
    urlPrefix: { type: String, default: '' },
    userRole: { type: String, required: true }
  },
  computed: {
    filteredSongs() {
      return this.songs.filter(s => s.artist_id == this.artist.id)
    }
  }
}
</script>
